import { render, staticRenderFns } from "./turnViewer.vue?vue&type=template&id=25510d33&scoped=true"
import script from "./turnViewer.vue?vue&type=script&lang=js"
export * from "./turnViewer.vue?vue&type=script&lang=js"
import style0 from "./turnViewer.vue?vue&type=style&index=0&id=25510d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25510d33",
  null
  
)

export default component.exports